export default function setSelectAllButtonAction(selectAllButton) {
    return {
        type: 'SET_SELECT_ALL',
        payload: selectAllButton
    }
}